import { createSlice } from '@reduxjs/toolkit'
import { getInitialState } from 'store/features/user/initialState'
import reducers from 'store/features/user/reducers'

const userSlice = createSlice({
  name: 'user',
  initialState: getInitialState(),
  reducers
})

export default userSlice
